// src/api/adminImportApi.ts
// Adaptador del IMPORTADOR MASIVO de clientes (super_admin) contra lealify-base.
// Reemplaza Firestore en ImportUsersPage: el selector de negocios (colección `businesses`)
// y la carga masiva (N× addDoc a `whatsappNumbers`) → ahora una sola llamada bulk a base.
// El parsing del TSV se queda en el cliente; aquí solo viajan filas ya procesadas.
import { baseApi } from './baseClient';

// Fila ya procesada por el parser del cliente (misma forma que ImportUsersPage.ImportRow).
// Se define aquí (idéntica) para que el adapter no dependa de la página: por tipado estructural
// las filas de la página son asignables sin import cruzado.
export interface ImportRow {
  name: string;
  phone: string;
  countryCode: string;
  points: number;
  createdAt: Date;
  birthDay: number | null;
  birthMonth: number | null;
  lastVisit: Date | null;
}

export interface ImportResult {
  imported: number;
  skipped: number;
  errors: { row: number; reason: string }[];
}

export const adminImportApi = {
  // Negocios para el selector (id+name), sin archivados, ordenados por nombre.
  listBusinesses: async (): Promise<{ id: string; name: string }[]> => {
    const r = await baseApi.get<{ businesses: { id: string; name: string }[] }>('/admin/businesses');
    return r.businesses;
  },

  // Importa las filas al negocio indicado en UNA llamada. Las fechas van como ISO strings
  // (el backend las parsea); el resto de campos se mandan tal cual.
  importClients: (tenantId: string, rows: ImportRow[]): Promise<ImportResult> =>
    baseApi.post<ImportResult>('/admin/import/clients', {
      tenant_id: tenantId,
      rows: rows.map((r) => ({
        name: r.name,
        phone: r.phone,
        countryCode: r.countryCode,
        points: r.points,
        createdAt: r.createdAt.toISOString(),
        birthDay: r.birthDay,
        birthMonth: r.birthMonth,
        lastVisit: r.lastVisit ? r.lastVisit.toISOString() : null,
      })),
    }),
};

export default adminImportApi;
